// Pure helpers for the AI document-analysis verdict cards (CompanyDetail).

export type DocumentAnalysisStatus = 'queued' | 'running' | 'succeeded' | 'failed' | 'skipped';

export type DocumentAnalysis = {
  id: string;
  submission_file_id: string;
  status: DocumentAnalysisStatus;
  trigger: 'submit' | 'retry';
  criteria_snapshot: string[];
  decision: 'approve' | 'reject' | null;
  confidence: number | null;
  summary: string | null;
  document_type: string | null;
  extraction_note: string | null;
  criteria_results:
    | { criterion: string; met: boolean; confidence: number | null; evidence: string | null }[]
    | null;
  // Usage/cost telemetry: recorded by the API and kept on this type so the data
  // stays auditable, but deliberately NOT rendered — the review UI showed a
  // tokens/neurons/cost footer that was operational noise to a reviewer.
  model: string | null;
  prompt_tokens: number | null;
  completion_tokens: number | null;
  pdf_extraction_tokens: number | null;
  neurons: number | null;
  estimated_usd: number | null;
  error: string | null;
  created_at: string;
  completed_at: string | null;
};

/** Rows arrive newest-first from the API; grouping preserves that order, so
 *  list[0] per file is the current verdict and the rest are history. */
export function groupAnalysesByFile(rows: DocumentAnalysis[]): Map<string, DocumentAnalysis[]> {
  const map = new Map<string, DocumentAnalysis[]>();
  for (const row of rows) {
    const list = map.get(row.submission_file_id);
    if (list) list.push(row);
    else map.set(row.submission_file_id, [row]);
  }
  return map;
}
